import React, { useEffect, useState } from "react"
import { ActionAnchor } from "@tenforce/toolbox-button-push-react"
import { Symbols } from "@tenforce/toolbox-fontmap"
import { getItemAncestry } from "../../../../apis/selectors"
import { addErrorNotification } from "../../../notifications/actions"
import { useAppDispatch } from "../../../../hooks"
import { itemDetailUrl } from "../../../../util/UrlGenerator"
import env from "../../../../env"
import { IItem } from "../../../../models"

export interface Props {
    id: number
}

export const ItemAncestry = ({ id }: Props): JSX.Element => {
    const dispatch = useAppDispatch()
    const [parents, setParents] = useState<IItem[]>([])
    const [isLoading, setIsLoading] = useState<boolean>(false)

    useEffect(() => {
        setIsLoading(true)
        getItemAncestry(id)
            .then(setParents)
            .catch((error) => {
                dispatch(
                    addErrorNotification(
                        error instanceof Error
                            ? error.message
                            : "Something went wrong when fetching ancestry.",
                    ),
                )
            })
            .finally(() => {
                setIsLoading(false)
            })
    }, [id])

    if (isLoading) {
        return (
            <>
                <ActionAnchor isLabel={true} extraClasses={"is-loading"}>
                    {Symbols.PlaceholderBig}
                </ActionAnchor>
                <span className="label is-dimmed tw-mx-1">/</span>
                <ActionAnchor isLabel={true} extraClasses={"is-loading"}>
                    {Symbols.PlaceholderBig}
                </ActionAnchor>
            </>
        )
    }
    if (parents.length === 0) {
        return <></>
    }

    return (
        <div className="tw-relative tw-z-10">
            {parents.map((parent, index) => {
                return (
                    <React.Fragment key={parent.id}>
                        {index > 0 && (
                            <span className="label is-dimmed tw-mx-1">/</span>
                        )}
                        <ActionAnchor
                            isLabel={true}
                            href={itemDetailUrl(
                                env.applicationPath,
                                "",
                                parent.id,
                            )}
                            extraClasses={isLoading ? "is-loading" : ""}
                        >
                            {parent.title}
                        </ActionAnchor>
                    </React.Fragment>
                )
            })}
        </div>
    )
}

export default ItemAncestry
